import React from 'react'
import { css } from '@emotion/react'
import { shape, string, number, bool } from 'prop-types'

import Card from '../ProductList/Card'

const subtitleCss = css`
  font-size: 16px;
  line-height: 20px;
  opacity: 0.6;
`

const ExpertCard = ({ item, isFeatured }) => {
  const { slug, name, logo2x, logo, shortDescription, reviewsNumber } = item

  const icons = { small: logo2x, title: name }
  const linkToExpert = `/partners/${slug}/`
  const subtitle =
    reviewsNumber && reviewsNumber > 0 ? (
      <span css={subtitleCss}>
        {reviewsNumber} review{reviewsNumber === 1 ? '' : 's'}
      </span>
    ) : (
      <span />
    )

  return (
    <Card
      link={linkToExpert}
      isFeatured={isFeatured}
      icons={icons}
      logo={logo}
      title={name}
      subtitle={subtitle}
      description={shortDescription}
    />
  )
}

ExpertCard.propTypes = {
  item: shape({
    slug: string,
    name: string,
    logo2x: string,
    shortDescription: string,
    reviewsNumber: number,
  }),
  isFeatured: bool,
}

export default ExpertCard
